module.exports = __webpack_public_path__ + "img/logo.2d9d9ec1.png";